export default __webpack_public_path__ + "static/media/indila.18518424.mp3";